import BotoesSalvarExcluir from '@/shared/components/forms/BotoesSalvarExcluir';
import Links from '@/shared/constants/navegacao';
import Loading from '@/shared/components/Carregando';
import ModalConflitos from './ModalConflitos';
import ModalExcluir from '@/shared/components/modals/ModalExcluir';
import ModalHistorico from '@/modules/system/historico/ModalHistorico';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { CreateLotacaoDto, ReadLotacaoDto, ReadSetorDto } from '@/api.types';
import { DataAmigavel, DataIso } from '@/shared/utils/datas';
import { EditadoPorRodape } from '@/shared/components/EditadoPorRodape';
import { Fragment, useCallback, useEffect, useMemo, useRef, useState, } from 'react';
import { IOpcao, SelectOption } from '@/shared/types/selectOption';
import { IOpcaoPredio, useCarregarDadosIniciais, } from './hooks/useDadosVinculo';
import { LotacaoService } from '@/modules/business/lotacoes/lotacao.service';
import { SelectInstance } from 'react-select';
import { Tabelas } from '@/shared/constants/tables';
import { TipoLotacao } from './enums/tipo-lotacao.enum';
import { TipoPessoaLotada } from './enums/tipo-pessoa-lotada.enum';
import { VinculoAnotacoesCard } from './cards/anotacoesCard';
import { VinculoDadosCard } from './cards/dadosCard';
import { VinculoLocalCard } from './cards/localCard';
import { VinculoPessoaCard } from './cards/pessoaCard';
import { isAxiosError } from 'axios';
import { readEstagiario } from '@/modules/people/estagiario.service';
import { toast } from 'react-toastify';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

type PostSaveAction = 'list' | 'continue' | 'addAnother';

export default function VinculoEditPage() {
  const { setActions } = useBreadcrumbActions();
  const lotacaoService = useMemo(() => new LotacaoService(), []);

  const navigate = useNavigate();

  const { pathname } = useLocation();

  const params = useParams();
  const id = params.id ? Number(params.id) : 0;
  const btnSalvar = id > 0 ? 'Salvar' : 'Cadastrar';
  const estagiarioid = params.estagiarioid ? Number(params.estagiarioid) : 0;
  const estagioid = params.estagioid ? Number(params.estagioid) : 0;

  const { register, handleSubmit, reset, getValues, setValue } = useForm<ReadLotacaoDto>();
  const [registro, setRegistro] = useState<ReadLotacaoDto>();
  const [isLoading, setIsLoading] = useState(false);

  const [tipoPessoaLotada, setTipoPessoaLotada] = useState<TipoPessoaLotada>(TipoPessoaLotada.Defensor);
  const [formKey, setFormKey] = useState(0);
  const postSaveActionRef = useRef<PostSaveAction | null>(null);
  const formRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    const novoHref = tipoPessoaLotada === TipoPessoaLotada.Estagiario
      ? Links.Vinculos_Estagio_Criar
      : tipoPessoaLotada === TipoPessoaLotada.Colaborador
        ? Links.Vinculos_Colaboradores_Criar
        : Links.Vinculos_Defensor_Criar;
    setActions({
      secondary: { label: 'Novo Registro', href: novoHref, onClick: () => {} },
      history: { label: 'Histórico', onClick: () => setModalHistorico(true) },
    });
    return () => setActions({});
  }, [setActions, tipoPessoaLotada]);

  // Caixas de seleção.
  const refSelectColaborador = useRef<SelectInstance<IOpcao | null>>(null);
  const refSelectDefensor = useRef<SelectInstance<IOpcao | null>>(null);
  const refSelectDefensoria = useRef<SelectInstance<IOpcao | null>>(null);
  const refSelectEstagiario = useRef<SelectInstance<IOpcao | null>>(null);
  const refSelectEstagio = useRef<SelectInstance<IOpcao | null>>(null);
  const refSelectNucleo = useRef<SelectInstance<IOpcao | null>>(null);
  const refSelectPredio = useRef<SelectInstance<IOpcao | null>>(null);
  const refSelectSetor = useRef<SelectInstance<IOpcao | null>>(null);
  const refSelectResponsavel = useRef<SelectInstance<SelectOption | null>>(null);

  // Modais e radios.
  const [modaExcluirShow, setModalExcluirShow] = useState(false);
  const [modalHistorico, setModalHistorico] = useState(false);
  const [modalConflitos, setModalConflitos] = useState(false);
  const [conflitos, setConflitos] = useState<any>(null);
  const [loaded, setLoaded] = useState(false);

  const [colaboradores, setColaboradores] = useState<IOpcao[]>([]);
  const [defensores, setDefensores] = useState<IOpcao[]>([]);
  const [defensorias, setDefensorias] = useState<IOpcao[]>([]);
  const [estagiarios, setEstagiarios] = useState<IOpcao[]>([]);
  const [pessoas, setPessoas] = useState<SelectOption[]>([])
  const [estagios, setEstagios] = useState<IOpcao[]>([]);
  const [nucleos, setNucleos] = useState<IOpcao[]>([]);
  const [predios, setPredios] = useState<IOpcaoPredio[]>([]);
  const [setoresDisponiveis, setSetoresDisponiveis] = useState<IOpcao[]>([]);

  const limparSelects = useCallback(() => {
    refSelectColaborador.current?.setValue(null, 'deselect-option');
    refSelectDefensor.current?.setValue(null, 'deselect-option');
    refSelectDefensoria.current?.setValue(null, 'deselect-option');
    refSelectEstagiario.current?.setValue(null, 'deselect-option');
    refSelectEstagio.current?.setValue(null, 'deselect-option');
    refSelectNucleo.current?.setValue(null, 'deselect-option');
    refSelectPredio.current?.setValue(null, 'deselect-option');
    refSelectSetor.current?.setValue(null, 'deselect-option');
    refSelectResponsavel.current?.setValue(null, 'deselect-option');
    setSetoresDisponiveis([]);
  }, []);

  const limparFormParaNovo = useCallback(() => {
    setValue('defensor', undefined);
    setValue('colaborador', undefined);
    setValue('estagio', undefined);
    limparSelects();
    setRegistro(undefined);
    reset(undefined);
    setFormKey((k) => k + 1);
  }, [limparSelects, reset, setValue]);

  const buscar = useCallback(async () => {
    await handleSelectChangeEstagiario(estagiarioid);

    if (id > 0) {
      await lotacaoService
        .Read(id)
        .then(async (result) => {
          if (result) {

            result.data_inicial = DataIso(result.data_inicial);
            result.data_final = DataIso(result.data_final);

            if (result.estagio?.estagiario)

              await handleSelectChangeEstagiario(result.estagio.estagiario.id!);

            setRegistro(result);
            reset(result);

            if (result.defensor)
              setTipoPessoaLotada(TipoPessoaLotada.Defensor);
            else if (result.colaborador)
              setTipoPessoaLotada(TipoPessoaLotada.Colaborador);
            else if (result.estagio)
              setTipoPessoaLotada(TipoPessoaLotada.Estagiario);
          }
        })
        .catch((res) => {
          toast.error((res as string) + '');
        });
    } else {
      setRegistro(undefined);
      reset(undefined);
    }
  }, [estagiarioid, id, lotacaoService, reset]);

  useEffect(() => {
    if (id <= 0) {
      if (pathname.includes(Links.Vinculos_Defensor_Criar))
        setTipoPessoaLotada(TipoPessoaLotada.Defensor);

      else if (pathname.includes(Links.Vinculos_Colaboradores_Criar))
        setTipoPessoaLotada(TipoPessoaLotada.Colaborador);

      else if (pathname.includes(Links.Vinculos_Estagio_Criar))
        setTipoPessoaLotada(TipoPessoaLotada.Estagiario);
    }
  }, [pathname]);

  useCarregarDadosIniciais({
    buscar,
    setColaboradores,
    setDefensores,
    setDefensorias,
    setEstagiarios,
    setPessoas,
    setLoaded,
    setNucleos,
    setPredios,
    setSetoresDisponiveis,
  });

  // Exclusão mútua defensoria/núcleo/setor é feita só no handleSelectChangeLocal (ao usuário
  // selecionar), para não zerar os campos ao carregar um registro existente na edição.

  useEffect(() => {

    if (predios.length > 0 && registro?.setor?.predio?.id) {
      const predioId = registro.setor.predio.id;
      const predioSelecionado = predios.find((predio) => predio.value === predioId);

      if (predioSelecionado && predioSelecionado.setores) {
        const setoresFiltrados = predioSelecionado.setores.map((setor: { id: number; nome: string }) => ({
          value: setor.id,
          label: setor.nome,
        }));
        setSetoresDisponiveis(setoresFiltrados);

        if (refSelectPredio.current) {
          const predioOption = predios.find((p) => p.value === predioId);
          if (predioOption) {
            refSelectPredio.current.setValue(predioOption, 'select-option');
          }
        }

        if (registro.setor?.id && refSelectSetor.current) {
          const setorId = registro.setor.id;
          const setorSelecionado = setoresFiltrados.find((s) => s.value === setorId);
          if (setorSelecionado) {
            refSelectSetor.current.setValue(setorSelecionado, 'select-option');
          }
        }
      }
    } else if (predios.length > 0 && !registro?.setor?.predio?.id) {
      setSetoresDisponiveis([]);
    }
  }, [predios, registro]);

  const onSubmit: SubmitHandler<CreateLotacaoDto> = async (obj) => {
    const action: PostSaveAction = postSaveActionRef.current ?? 'list';
    postSaveActionRef.current = null;

    // Limpa campos desnecessários antes de enviar
    if (!obj.setor)
      obj.setor = undefined;

    // Assegura ser apenas defensoria ou núcleo (o backend valida isso, mas limpamos aqui também)
    if (obj.defensoria?.id) {
      delete obj.nucleo;
    } else if (obj.nucleo?.id) {
      delete obj.defensoria;
    }

    // Remove propriedade predio (usada apenas para filtrar setores)
    if ('predio' in obj) {
      delete (obj as any).predio;
    }

    //@ts-expect-error ts2322
    obj.data_inicial = obj.data_inicial && obj.data_inicial?.length >= 10 ? DataIso(obj.data_inicial) : null
    //@ts-expect-error ts2322
    obj.data_final = obj.data_final && obj.data_final?.length >= 10 ? DataIso(obj.data_final) : null

    if (obj.entrada === '') delete obj.entrada;
    if (obj.saida === '') delete obj.saida;

    setIsLoading(true);
    if (id > 0) {
      await lotacaoService
        .Update(obj, id)
        .then((res) => {
          if (res === true) {
            toast.success(`Registro atualizado com sucesso.`);
            if (action === 'list') {
              navigate(Links.Vinculos_Index);
            } else if (action === 'addAnother') {
              limparFormParaNovo();
              const novoHref = tipoPessoaLotada === TipoPessoaLotada.Estagiario
                ? Links.Vinculos_Estagio_Criar
                : tipoPessoaLotada === TipoPessoaLotada.Colaborador
                  ? Links.Vinculos_Colaboradores_Criar
                  : Links.Vinculos_Defensor_Criar;
              navigate(novoHref);
            } else if (action === 'continue') {
              void buscar();
            }
          } else toast.warning(res);
        })
        .catch((error) => {
          // Verifica se é um erro de conflitos
          if (isAxiosError(error) && error.response?.status === 400) {
            const errorData = error.response.data;
            // Verifica se a resposta contém a estrutura de conflitos
            if (errorData && errorData.conflitos && Array.isArray(errorData.conflitos)) {
              setConflitos(errorData);
              setModalConflitos(true);
              return;
            }
          }
          toast.error((error as string) + '');
        })
        .finally(() => setIsLoading(false));
    } else {
      setIsLoading(true);
      await lotacaoService
        .Create(obj)
        .then((res) => {
          if (!isNaN(res as number)) {
            const newId = Number(res);
            toast.success(`Registro salvo com sucesso.`);
            if (action === 'list') {
              navigate(Links.Vinculos_Index);
            } else if (action === 'addAnother') {
              limparFormParaNovo();
              const novoHref = tipoPessoaLotada === TipoPessoaLotada.Estagiario
                ? Links.Vinculos_Estagio_Criar
                : tipoPessoaLotada === TipoPessoaLotada.Colaborador
                  ? Links.Vinculos_Colaboradores_Criar
                  : Links.Vinculos_Defensor_Criar;
              navigate(novoHref);
            } else if (action === 'continue' && newId) {
              navigate(`${Links.Vinculos_Editar}/${newId}`);
            }
          } else toast.warning(res);
        })
        .catch((error) => {
          // Verifica se é um erro de conflitos
          if (isAxiosError(error) && error.response?.status === 400) {
            const errorData = error.response.data;
            // Verifica se a resposta contém a estrutura de conflitos
            if (errorData && errorData.conflitos && Array.isArray(errorData.conflitos)) {
              setConflitos(errorData);
              setModalConflitos(true);
              return;
            }
          }
          toast.error((error as string) + '');
        })
        .finally(() => setIsLoading(false));
    }
  };

  const handleExcluir = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    setModalExcluirShow(false);
    lotacaoService
      .Delete(id)
      .then((res) => {
        toast.success(res + '');
        navigate(`${Links.Vinculos_Index}`);
      })
      .catch((res) => {
        toast.error((res as string) + '');
      });
  };

  const handleSelectChangeEstagiario = useCallback(async (idEstagiario: number) => {
    if (refSelectEstagio.current) {
      refSelectEstagio.current.setValue(null, 'deselect-option');
    }

    if (idEstagiario > 0) {
      try {
        const res = await readEstagiario({ id: idEstagiario, skip: 0, take: 1, comEstagios: true });
        if (res[0][0]?.estagios) {
          const listaEstagios = res[0][0].estagios.map((item) => ({
            value: item.id,
            label: `${DataAmigavel(item.data_inicio_estagio)} - ${TipoLotacao[item.tipo_estagio]}`,
          }));

          setEstagios(listaEstagios);
        }
      } catch (err) {
        console.warn(err);
      }
    } else {
      setEstagios([]);
      refSelectEstagio.current?.setValue(null, 'deselect-option');
    }
  }, [setEstagios]);

  // Handler específico para o card de Pessoa
  const handleSelectChangePessoa = useCallback(async (
    selectedOption: IOpcao | null,
    options: IOpcao[],
    field: 'defensor' | 'colaborador' | 'estagiario' | 'estagio'
  ) => {
    if (selectedOption) {
      const selectedItem = options.find(
        (option) => option.value === selectedOption.value,
      );

      if (selectedItem) {
        const newValue = { id: selectedItem.value, nome: selectedItem.label };

        if (field === 'estagiario') {
          await handleSelectChangeEstagiario(selectedItem.value);
          return;
        }

        // Tratamento especial para estagio: preserva o estagiario existente
        if (field === 'estagio') {
          const currentEstagio = getValues('estagio');
          const currentEstagiario = currentEstagio?.estagiario;

          // Preserva o estagiario que já está no form ou busca do estagiario selecionado
          let estagiarioToPreserve = currentEstagiario;
          if (!estagiarioToPreserve && estagiarioid > 0) {
            const estagiarioOption = estagiarios.find(e => e.value === estagiarioid);
            if (estagiarioOption) {
              estagiarioToPreserve = {
                id: estagiarioOption.value,
                pessoa: {
                  id: '',
                  nome: estagiarioOption.label
                },
                ativo: true
              };
            }
          }

          const estagioValue = {
            id: selectedItem.value,
            estagiario: estagiarioToPreserve!
          };

          setValue('estagio', estagioValue);
          return;
        }

        setValue(field as any, newValue);
      }
    } else if (field === 'estagio') {
      // Se estagio foi desmarcado, remove o estagio mas preserva o estagiario se necessário
      setValue('estagio', undefined);
    } else {
      setValue(field as any, undefined);
    }
  }, [estagiarioid, estagiarios, getValues, setValue, handleSelectChangeEstagiario]);

  // Handler específico para o card de Local
  const handleSelectChangeLocal = useCallback((
    selectedOption: IOpcao | null,
    options: IOpcao[],
    field: 'defensoria' | 'nucleo' | 'predio' | 'setor'
  ) => {
    if (field === 'predio') {
      const predioSelecionado = selectedOption
        ? predios.find((predio) => predio.value === selectedOption.value)
        : null;

      let setoresAssociados: ReadSetorDto[] = [];
      if (predioSelecionado && predioSelecionado.setores) {
        setoresAssociados = predioSelecionado.setores;
      }

      setSetoresDisponiveis(
        setoresAssociados.map((setor: { id: number; nome: string }) => ({
          value: setor.id,
          label: setor.nome,
        })),
      );

      // Limpa a seleção do setor quando o prédio muda
      if (refSelectSetor.current) {
        refSelectSetor.current.setValue(null, 'deselect-option');
      }
      setValue('setor', undefined);

      // Não salva o predio no form, ele é apenas para filtrar setores
      return;
    }

    if (selectedOption) {
      const selectedItem = options.find(
        (option) => option.value === selectedOption.value,
      );

      if (selectedItem) {
        const newValue = { id: selectedItem.value, nome: selectedItem.label };
        setValue(field as any, newValue);
        // Exclusão mútua: ao escolher defensoria, limpa núcleo e setor; ao escolher núcleo, limpa defensoria
        if (field === 'defensoria') {
          if (refSelectNucleo.current) refSelectNucleo.current.setValue(null, 'deselect-option');
          if (refSelectSetor.current) refSelectSetor.current.setValue(null, 'deselect-option');
          if (refSelectPredio.current) refSelectPredio.current.setValue(null, 'deselect-option');
          setValue('nucleo', undefined);
          setValue('setor', undefined);
        } else if (field === 'nucleo') {
          if (refSelectDefensoria.current) refSelectDefensoria.current.setValue(null, 'deselect-option');
          setValue('defensoria', undefined);
        }
      }
    } else {
      setValue(field as any, undefined);
    }
  }, [id, predios, setSetoresDisponiveis, setValue, refSelectSetor]);

  // Handler específico para o card de Dados
  const handleSelectChangeDados = useCallback((
    selectedOption: SelectOption | null,
    options: SelectOption[],
    field: 'responsavel'
  ) => {
    if (selectedOption) {
      const selectedItem = options.find(
        (option) => option.value === selectedOption.value,
      );

      if (selectedItem) {
        const newValue = { id: selectedItem.value, nome: selectedItem.label };
        setValue(field, newValue);
      }
    } else {
      setValue(field, undefined);
    }
  }, [setValue]);

  useEffect(() => {
    if (estagios.length > 0) {
      // Prioriza o estagio do registro carregado, depois o estagioid da URL
      const currentEstagioId = getValues('estagio')?.id;
      const estagioIdToUse = currentEstagioId || estagioid;

      if (estagioIdToUse) {
        const selected = estagios.find((e) => e.value === estagioIdToUse);
        if (selected && refSelectEstagio.current) {
          refSelectEstagio.current.setValue(selected, 'select-option');
        }
      }
    }
  }, [estagios, estagioid, getValues]);

  if (!loaded)
    return <Loading />;

  return (
    <Fragment>
      <div className="row">
        <div className="col-12">
          <h3 className="pt-3">Cadastro de Vínculos</h3>
          <span className="blockquote-footer pb-4 text-end">
            Permite vincular uma pessoa em uma local.
          </span>
        </div>
      </div>
      <hr />

      <form
        key={formKey}
        ref={formRef}
        onSubmit={(event) => {
          void handleSubmit(onSubmit)(event);
        }}
      >
        <div className="row">
          <div className="col-md-6">
            <div>
              <VinculoPessoaCard
                getValues={getValues}
                colaboradores={colaboradores}
                defensores={defensores}
                estagiarioid={estagiarioid}
                estagiarios={estagiarios}
                estagioid={estagioid}
                estagios={estagios}
                refSelectColaborador={refSelectColaborador}
                refSelectDefensor={refSelectDefensor}
                refSelectEstagiario={refSelectEstagiario}
                refSelectEstagio={refSelectEstagio}
                tipoPessoaLotada={tipoPessoaLotada}
                handleSelectChange={handleSelectChangePessoa}
              />
            </div>

            <div className="mt-3">
              <VinculoDadosCard
                getValues={getValues}
                handleSelectChange={handleSelectChangeDados}
                pessoas={pessoas}
                refSelectResponsavel={refSelectResponsavel}
                register={register}
                tipoPessoaLotada={tipoPessoaLotada}
              />
            </div>
          </div>

          <div className="col-md-6">
            <div>
              <VinculoLocalCard
                defensorias={defensorias}
                getValues={getValues}
                handleSelectChange={handleSelectChangeLocal}
                nucleos={nucleos}
                predios={predios as unknown as IOpcao[]}
                refSelectDefensoria={refSelectDefensoria}
                refSelectNucleo={refSelectNucleo}
                refSelectPredio={refSelectPredio}
                refSelectSetor={refSelectSetor}
                setoresDisponiveis={setoresDisponiveis}
              />
            </div>
          </div>
          <div className="mt-4">
            <VinculoAnotacoesCard register={register} />
          </div>

          <EditadoPorRodape
            dados={{
              editadoPor: registro?.editadoPor,
              editadoEm: registro?.editadoEm,
            }}
          />

          <div>
            <BotoesSalvarExcluir
              isLoading={isLoading}
              texto={btnSalvar}
              textoLoading={btnSalvar === 'Cadastrar' ? ' Cadastrando...' : ' Salvando...'}
              id={id}
              onExcluirClick={() => setModalExcluirShow(true)}
              onSalvarEAdicionarOutros={() => {
                postSaveActionRef.current = 'addAnother';
                formRef.current?.requestSubmit();
              }}
              onSalvarEContinuar={() => {
                postSaveActionRef.current = 'continue';
                formRef.current?.requestSubmit();
              }}
            />
          </div>
        </div>
      </form>

      <ModalExcluir
        show={modaExcluirShow}
        handleExcluir={handleExcluir}
        handleHide={() => setModalExcluirShow(false)}
      ></ModalExcluir>
      <ModalHistorico
        show={modalHistorico}
        handleHide={() => setModalHistorico(false)}
        tabela={Tabelas.lotacao}
        idRegistro={id}
      ></ModalHistorico>
      <ModalConflitos
        show={modalConflitos}
        handleHide={() => setModalConflitos(false)}
        conflitos={conflitos}
      ></ModalConflitos>
    </Fragment>
  );
}
